import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/app'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

import Amplify from 'aws-amplify'
import aws_exports from './AppSyncConfig'

Amplify.configure(aws_exports)

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: function () {
    const check = localStorage.getItem('APP_UPDATE')
    if (!check) {
      localStorage.setItem('APP_UPDATE', 'ready')
    }
  }
})

// pwa elements https://capacitorjs.com/docs/web/pwa-elements
// at the moment we do not need this
// defineCustomElements(window);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
